import * as ko from "knockout";
import Bao from "./../../../services/bao-service";
import BaoDialogViewModel from "./../../../factories/bao-dialog";
import "./../../../bindings/bao-tabs";
function UserAccountAssignmentDialog(tabPage, parent) {
    var self = this;
    self.Dialog = new BaoDialogViewModel(Bao.Session.ApplicationName);
    self.Dialog.Width("750px");
    self.Dialog.Buttons([{
            Title: Bao.Session.GetMessage("msgOk"),
            Click: function () {
                if (!self.ValidateDialog()) {
                    return;
                }
                self.DialogResult("ok");
                self.Dialog.Close();
            },
            Enabled: ko.observable(true)
        }, {
            Title: Bao.Session.GetMessage("msgCancel"),
            Click: function () {
                self.Dialog.Close();
            },
            Enabled: ko.observable(true)
        }]);
    self.DialogViewModel = {};
    self.DialogViewModel.Bao = Bao;
    self.DialogViewModel.SelectedMandatorId = ko.observable();
    self.DialogViewModel.SelectedCustomerId = ko.observable();
    self.DialogViewModel.AccountAssignmentTypeId = ko.observable();
    self.DialogViewModel.AccountAssignmentTypeName = ko.observable();
    self.DialogViewModel.AccountAssignment = ko.observable();
    self.DialogViewModel.SelectedAccountAssignment = ko.observable();
    self.DialogViewModel.SelectedAccountAssignment.subscribe(function (item) {
        self.DialogViewModel.AccountAssignmentTypeId(item.AccountAssignmentTypeId);
        self.DialogViewModel.AccountAssignmentTypeName(item.AccountAssignmentTypeName);
    });
    self.DialogViewModel.Focus = function () { };
    self.DialogResult = ko.observable();
    self.ValidateDialog = function () {
        var isComplete = true;
        if (self.DialogViewModel.AccountAssignmentTypeId() == null) {
            isComplete = false;
        }
        if (Bao.Utils.String.IsNullOrEmpty(self.DialogViewModel.AccountAssignment())) {
            isComplete = false;
        }
        if (isComplete == false) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return isComplete;
    };
    self.Show = function (userId, mandatorId, customerId, accountAssignmentTypeId, accountAssignment) {
        tabPage.IsLoading(true);
        self.DialogViewModel.SelectedMandatorId(mandatorId);
        self.DialogViewModel.SelectedCustomerId(customerId);
        Bao.post("UadmCustom/UserTab/ShowUserAccountAssignmentDialog", JSON.stringify({
            sessionTabId: parent.User.TabPage.SessionTabId,
            userId: userId,
            customerId: customerId,
            accountAssignmentTypeId: accountAssignmentTypeId,
            accountAssignment: accountAssignment
        })).then(function (value) {
            ko.map.fromJS(value.Model, self.DialogViewModel);
            self.Dialog.ViewModel(self.DialogViewModel);
            self.Dialog.Template(value.Message);
            self.Dialog.Open();
            self.DialogViewModel.Focus();
            tabPage.IsLoading(false);
        });
    };
}
export default UserAccountAssignmentDialog;